var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{ref:"dialogDom",staticClass:"preview-modal-container",attrs:{"isShow":true,"mask":true},on:{"close":_vm.closeDialog}},[_c('iframe',{ref:"previewFrame",attrs:{"src":_vm.url,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }